import { Component, input } from "@angular/core";
import { WkTranslatePipe } from "@shared/index";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

enum AppLoaderSize {
    Small = "small",
    Medium = "medium",
    Large = "large",
    Button = "button",
}

enum AppLoaderPosition {
    Right = "right",
    Left = "left",
}

type AppLoaderSizeType = "small" | "medium" | "large" | "button";
type AppLoaderPositionType = "right" | "left";

@Component({
    selector: "app-loader",
    templateUrl: "./app-loader.component.html",
    styleUrl: "./app-loader.component.scss",
    host: { class: "wk-app-loader" },
    imports: [WkTranslatePipe, JumpstartComponentsModule],
})
export class AppLoaderComponent {
    protected AppLoaderSize = AppLoaderSize;
    protected AppLoaderPosition = AppLoaderPosition;

    public text = input("");
    public isOverlay = input(true);
    public size = input<AppLoaderSizeType>(AppLoaderSize.Medium);
    public position = input<AppLoaderPositionType>(AppLoaderPosition.Right);

    isLoading = input<boolean>(true);
}
